import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { Link } from "react-router-dom";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { siteConfig } from "../../config/site";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  ContactLink,
  AddressText,
  FooterContainer,
  Language,
  Copyright,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between" gutter={[32, 32]}>
            <Col lg={10} md={10} sm={24} xs={24}>
              <Language>{t("Support")}</Language>
              <ContactLink href={`mailto:${siteConfig.supportEmail}`}>
                {siteConfig.supportEmail}
              </ContactLink>
              <Para>{t("Do you have any question? Feel free to reach out.")}</Para>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <Title>{t("Contact Number")}</Title>
              <ContactLink href={`tel:${siteConfig.supportPhone.replace(/\s/g, "")}`}>
                {siteConfig.supportPhone}
              </ContactLink>
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <Title>{t("Company Address")}</Title>
              <AddressText>{siteConfig.address}</AddressText>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row justify="space-between" align="middle" style={{ paddingTop: "2rem" }}>
            <NavLink to="/" aria-label="MyDealCase homepage">
              <LogoContainer>
                <SvgIcon src="logo.svg" alt="MyDealCase logo" width="101px" height="64px" />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <Link to="/privacy-policy">{t("Privacy Policy")}</Link>
              <Link to="/terms-and-conditions">{t("Terms & Conditions")}</Link>
              <Copyright>
                © {siteConfig.copyrightYear} {siteConfig.companyName}
              </Copyright>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
